import { ca } from '@cian/analytics';

import { IOffer } from '../../../../fragments/OfferCardWidget/shared/types/offer';

export function trackModalOpen(
  offer: IOffer,
  position: number,
  placeType: string | undefined,
  isEarlyAccess?: boolean,
  source?: string,
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'open',
    label: offer.gaLabel,
    products: [
      {
        id: offer.id,
        offerType: 'offer',
        position,
      },
    ],
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        /* istanbul ignore next */
        opponent_id: offer.user?.cianUserId,
        type: placeType,
        is_early_access: Boolean(isEarlyAccess),
        source,
      },
    },
  });
}
